const lineChartHeight = 400;

const devUrl = 'https://wndr-staging.azurewebsites.net/api/';
// const devUrl = 'http://localhost:3001/api/';
const prodUrl = `${window.location.protocol}//${window.location.host}/api`;

export const config = {
  apiUrl: process.env.NODE_ENV === 'production' ? prodUrl : devUrl,
  sessionEndMessageTimeout: 3300000,
  logoutTimeout: 300000,
  itemsPerPage: 12,
  snackDuration: 3000,
  lineChartDimensions: {
    width: 700,
    height: lineChartHeight,
  },
  funnelDimensions: {
    width: 300,
    height: lineChartHeight,
  },
  acceptedFiles: ['.jpeg', '.jpg', '.png'],
  maxFileSize: 1048576,
  generateActivationCodesAmount: 100,
};
